<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path d="M14.7146 15.2142L5.28648 5.78612" stroke="white" stroke-linecap="round" />
    <path d="M14.7135 5.78612L5.28543 15.2142" stroke="white" stroke-linecap="round" />
  </svg>
</template>
